import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularOpen: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_open"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="open icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 28 28"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M7.24998 4.5C5.73121 4.5 4.49999 5.73122 4.49999 7.25V20.75C4.49999 22.2688 5.73121 23.5 7.24998 23.5H20.7499C22.2687 23.5 23.4999 22.2688 23.4999 20.75V16.25C23.4999 15.8358 23.8357 15.5 24.2499 15.5C24.6641 15.5 24.9999 15.8358 24.9999 16.25V20.75C24.9999 23.0972 23.0971 25 20.7499 25H7.24998C4.90278 25 3 23.0972 3 20.75V7.25C3 4.90279 4.90278 3 7.24998 3H11.75C12.1642 3 12.5 3.33579 12.5 3.75C12.5 4.16421 12.1642 4.5 11.75 4.5H7.24998ZM15.5002 3.75C15.5002 3.33579 15.836 3 16.2502 3H24.25C24.6642 3 25 3.33579 25 3.75V11.75C25 12.1642 24.6642 12.5 24.25 12.5C23.8358 12.5 23.5 12.1642 23.5 11.75V5.5607L17.2805 11.7802C16.9876 12.0731 16.5127 12.0731 16.2199 11.7802C15.927 11.4873 15.927 11.0124 16.2199 10.7196L22.4394 4.5H16.2502C15.836 4.5 15.5002 4.16421 15.5002 3.75Z" />
      </svg>
    </span>
  );
};

export { RegularOpen };
